export default __webpack_public_path__ + "static/media/minki-img.64feb5c8.png";